export const validacion = (tipo, valor, regex) => {
  valor = valor.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  switch (tipo) {
    case "NUMERICO":
      if (!/^[0-9]+$/.test(valor)) {
        return true;
      }
      return false;
    case "ALFANUMERICO":
      if (!/^[a-zA-Z\d]+$/.test(valor)) {
        return true;
      }
      return false;
    case "ALFABETICO":
      if (!/^[a-zA-Z]+$/.test(valor)) {
        return true;
      }
      return false;
    case "MONEDA":
      if (!/^(([1-9]\d{0,2}(\.\d{3})*)|0)?$/.test(valor)) {
        return true;
      }
      return false;
    case "CORREO":
      if (!/^[a-zA-Z._%+-\d]+@[a-zA-Zd.-\d]+\.[a-zA-Z]{2,6}$/.test(valor)) {
        return true;
      }
      return false;
    default:
      let rgx = new RegExp(regex, "g");
      if (!rgx.test(valor)) {
        return true;
      }
      return false;
  }
};



// WEBPACK FOOTER //
// ./src/utils/ValidacionGenerica.js